_ = require 'underscore'
$ = require 'jquery'
ApiPromise = require 'network/api-promise'
AutocompleteMemberAvatar = require 'views/organization/invite-member-autocomplete-avatar'
Promise = require 'bluebird'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
templates = require 'views/internal/templates'
track = require 'debug/track'

emailRegex = /([^"@\s\[\]\(\),:;<>\\]+@[-a-z0-9\.]+\.[a-z]+)/gi
usernameRegex = /^@[a-z0-9_]{3,}$/

module.exports = class MemberMultiSelectAutocompleteComponent extends React.Component
  constructor: (props) ->
    super
    @updateSearchResultList = _.debounce(@updateSearchResultList, 250)
    @searchForMembersPromise = null
    @searchForMembers = @searchForMembers.bind(@)
    @selectMemberOption = @selectMemberOption.bind(@)
    @onInputChange = @onInputChange.bind(@)
    @onInputFocus = @onInputFocus.bind(@)
    @onInputBlur = @onInputBlur.bind(@)
    @onInputKeyUp = @onInputKeyUp.bind(@)
    @onInputKeyDown = @onInputKeyDown.bind(@)
    @onInputPaste = @onInputPaste.bind(@)
    @onAutocompleteKeyDown = @onAutocompleteKeyDown.bind(@)
    @onAutocompleteSubmit = @onAutocompleteSubmit.bind(@)
    @searchCache = {}
    @state =
      activeIndex: -1
      isOpen: false
      isFetching: false
      processingMembers: false
      isActive: true
      isTyping: false
      searchResults: []
      searchText: ''
      shouldFocusOnUpdate: false

  _sanitizeEmail = (email) ->
    return $.trim(email).toLowerCase().match(emailRegex)

  _sanitizeUsername = (username) ->
    return $.trim(username).toLowerCase().replace(/@/g, '')

  componentDidMount: ->
    @refs.searchInput.focus()

  componentDidUpdate: ->
    if @state.shouldFocusOnUpdate
      @refs.searchInput.focus()
      @setState({ shouldFocusOnUpdate: false })

    # Sometimes we lose focus without calling the onBlur handler, we should
    # update the state in these cases
    if @state.isActive && (document.activeElement != @refs.searchInput)
      @setState({
        isOpen: false
        isActive: false
      })

  componentWillUnmount: ->
    @searchForMembersPromise?.cancel()

  updateSearchResultList: (searchVal) ->
    if !searchVal
      return

    searchResultList = @searchCache[searchVal]
    if searchResultList
      @receiveSearchResults(searchResultList)
    else
      @searchForMembers searchVal

  searchForMembers: (query, cb) ->
    { onAutocompleteSearch } = @props
    @searchForMembersPromise?.cancel()
    @searchForMembersPromise = Promise.try =>
      if usernameRegex.test(query)
        query = _sanitizeUsername(query)
      else if emailRegex.test(query)
        query = _sanitizeEmail(query)[0]
      @setState({ isFetching: true, isOpen: true })
      onAutocompleteSearch(query)
    .cancellable()
    .then (resultList = []) =>
      @searchCache[query] = resultList
      @receiveSearchResults(resultList, query)
    .catch Promise.CancellationError, (=> @setState({ isFetching: false }))
    .catch (err) => @setState({ isFetching: false, error: err })

  receiveSearchResults: (searchResults, query) ->
    { emptySearchText } = @props
    searchResults = _.filter(searchResults, (result) =>
      result.active and (result.email || result.username)
    )
    @setState({
      isOpen: @state.isTyping and (
        searchResults?.length or (emptySearchText? and query?.length > 2)
      )
      isFetching: false
      searchResults
    })

  selectMemberOption: (e, member) ->
    e.preventDefault()
    { onSelectMemberOption } = @props
    @searchForMembersPromise?.cancel()

    @setState({
      searchText: ''
      isOpen: false
      shouldFocusOnUpdate: true
    })
    onSelectMemberOption(member)

  onInputBlur: (e) ->
    if emailRegex.test(e.target.value)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(e.target.value), (email) => { email }
      ))
    @setState({
      isOpen: false
      isActive: false
    })

  onInputChange: (e) ->
    e.persist()
    searchText = e.target.value
    @setState({
      searchText,
      isOpen: false
      error: undefined
    })
    @updateSearchResultList(searchText)

  onInputFocus: (e) ->
    if @props.searchOnFocus
      @setState({ isTyping: true })
      @searchForMembers(@state.searchText)
    @setState({ isActive: true })

  onInputKeyUp: (e) ->
    { searchText } = @state
    { selectedOptions } = @props

    if e.key in ['Enter', ',', ' '] and emailRegex.test(e.target.value) # enter, comma, or spacebar
      e.preventDefault()
      @setState({
        isOpen: false
        isTyping: false
      })
      # stop any running search queries
      @searchForMembersPromise?.cancel()
      # map out emails in the case of bulk copy + paste
      @selectMemberOption(e, _.map(
        _sanitizeEmail(e.target.value), (email) => { email }
      ))
    else if e.key is not 'Backspace' or e.target.value or !selectedOptions.length
      @setState({ isTyping: true })

  onInputKeyDown: (e) ->
    { onRemoveMemberOption, selectedOptions } = @props

    if e.key is 'Backspace' and !e.target.value and selectedOptions.length
      onRemoveMemberOption(selectedOptions.length - 1)
      @setState shouldFocusOnUpdate: true

  onInputPaste: (e) ->
    clipboardValue = e.clipboardData.getData('Text')
    if emailRegex.test(clipboardValue)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(clipboardValue), (email) => { email }
      ))

  onAutocompleteKeyDown: (e) ->
    { activeIndex, searchResults } = @state
    switch e.key
      when 'Enter'
        if searchResults[activeIndex] and !searchResults[activeIndex].joined
          @setState({ activeIndex: -1 })
          @selectMemberOption(e, searchResults[activeIndex])
      when 'ArrowRight', 'ArrowDown'
        nextIndex = if activeIndex == searchResults.length - 1 then -1  else activeIndex + 1
        @setState({ activeIndex: nextIndex })
      when 'ArrowLeft', 'ArrowUp'
        prevIndex = if activeIndex == -1 then searchResults.length - 1 else activeIndex - 1
        @setState({ activeIndex: prevIndex })
      else null

  onAutocompleteSubmit: (e) ->
    { searchText } = @state
    { onSubmit, selectedOptions } = @props
    if emailRegex.test(searchText)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(searchText), (email) => { email }
      ))

    users = _.map(selectedOptions, (option) =>
      if option.email then option.email else option.username
    )

    @setState({ processingMembers: true })
    onSubmit(users)
    .catch (err) =>
      @setState({ processingMembers: false, error: err })

  render: t.renderable ->
    {
      activeIndex,
      isActive,
      isFetching,
      isOpen,
      processingMembers,
      searchResults,
      searchText,
      error
    } = @state
    {
      placeholder,
      displayDetails,
      displayOrg,
      displayUsername,
      emptySearchText,
      submitText,
      children,
      extraSearchOption,
      selectedOptions,
      onRemoveMemberOption
    } = @props

    validEmail = searchText.match(emailRegex)
    atLeastOnePill = selectedOptions.length > 0
    buttonIsEnabled = ((!atLeastOnePill and validEmail) or atLeastOnePill) and !processingMembers

    t.div '.multi-select-autocomplete-container', =>
      t.div '.autocomplete-input-container', {
        class: t.classify({
          active: isActive or selectedOptions.length
          processing: processingMembers
          'is-empty': !selectedOptions.length
        })
        onKeyDown: @onAutocompleteKeyDown
      }, =>
        t.div '.autocomplete-selected', =>
          if selectedOptions.length
            selectedOptions.map((member, idx) =>
              t.div '.autocomplete-option', {
                className: if member.hasError? then 'has-error' else ''
              }, =>
                t.createElement AutocompleteMemberAvatar,
                  _.extend {
                    onRemoveClick: (e) => onRemoveMemberOption(idx)
                  }, member
            )

          t.input '.autocomplete-input',
            type: 'text'
            onBlur: @onInputBlur
            onChange: @onInputChange
            onKeyUp: @onInputKeyUp
            onKeyDown: @onInputKeyDown
            onFocus: @onInputFocus
            onPaste: @onInputPaste
            disabled: processingMembers
            placeholder: if selectedOptions.length then '' else placeholder
            value: searchText
            style:
              minWidth: "#{Math.min((searchText?.length * 8) + 2, 264)}px"
            ref: 'searchInput'

        if isOpen
          if isFetching
            t.div '.autocomplete-search-results', =>
              t.div '.spinner.loading'
          else
            if searchResults.length > 0
              t.div '.autocomplete-search-results', {
                className: if extraSearchOption? then 'has-extra-option' else ''
              }, =>
                t.div '.autocomplete-search-scroll', =>
                  searchResults.map((member, idx) =>
                    memberAlreadySelected = _.find(selectedOptions, ({ id }) ->
                      id == member.id
                    )
                    disabled = memberAlreadySelected or member.joined or member.isDeactivated
                    activeMember = activeIndex == idx and !disabled
                    return t.div '.autocomplete-option', {
                      class: t.classify({
                        disabled
                        active: activeMember
                      })
                    }, =>
                      t.createElement AutocompleteMemberAvatar,
                        _.extend {
                          onMouseDown: (e) => @selectMemberOption(e, member)
                          displayDetails: displayDetails
                          displayOrg: displayOrg
                        }, member
                    )
                if extraSearchOption
                  t.addElement extraSearchOption
            else if emptySearchText?
              t.div '.autocomplete-search-results.is-empty', ->
                t.text emptySearchText
        else if error?
          t.div '.autocomplete-search-results.is-empty', ->
            t.text error.message

      for index, child of children
        t.addElement child

      t.button '.autocomplete-btn.primary', {
        class: t.classify({ disabled: !buttonIsEnabled })
        disabled: !buttonIsEnabled
        onClick: @onAutocompleteSubmit
      }, ->
        if processingMembers
          t.div '.spinner.loading'
        else
          t.text submitText



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-multi-select-autocomplete-component.coffee